import React from "react";
import { Box } from "@mui/material";
import CommonRequiredLabel from "../CommonRequiredLabel/CommonRequiredLabel";
import CommonErrorMessage from "../CommonErrorMessage/CommonErrorMessage";

const CommonFieldWrapper = ({
  label,
  required = false,
  labelStyle,
  error,
  errorSx,
  wrapperSx,
  className,
  showLabel = true,
  children,
}) => (
  <Box sx={wrapperSx} className={className}>
    {showLabel && (
      <CommonRequiredLabel label={label} required={required} style={labelStyle} />
    )}
    {children}
    <CommonErrorMessage error={error} sx={errorSx} />
  </Box>
);

export default CommonFieldWrapper;
